import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import SwiperCore, {Navigation} from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import {Container, TextField} from '@material-ui/core';

import MySwiper from 'components/Shared/MySwiper';
import VODCard from 'components/VODCard';

import './VODCarousel.scss';

SwiperCore.use([Navigation]);

function VODCarousel({vods, cinemaId, userRentals = [], currentFilmId}) {
  const {t} = useTranslation();
  const [searchString, setSearchString] = useState('');

  const swiperProps = {
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
      // when window width is >=
      450: {
        slidesPerView: 2,
      },
      // when window width is >=
      800: {
        slidesPerView: 3,
      },
      // when window width is >=
      1100: {
        slidesPerView: 5,
      },
    },
    pagination: {clickable: true},
    scrollbar: {draggable: true},
  };

  const checkIfRented = vod => userRentals && userRentals.filter(u => u?.film?.id === vod.film.id).length;

  return (
    <Container maxWidth="lg">
      <div className="spacer" />
      <div className="spacer" />
      <div className="VODCarousel">
        <MySwiper
          titleHeader={t('vod')}
          params={swiperProps}
          list={vods
            .filter(e => e.film.id !== parseInt(currentFilmId)) // Remove current page's film
            .filter(vod => vod?.film?.name.toLowerCase().includes(searchString.toLowerCase()))
            .map(vod => (
              <VODCard vod={vod} cinemaId={cinemaId} isRent={checkIfRented(vod)} />
            ))}
        >
          <div className="Vod-MLC-header-searchbar">
            <TextField
              className="Vod-MLC-header-input"
              label={t('rechercher-un-film-en-vod')}
              value={searchString}
              onChange={e => {
                setSearchString(e.target.value);
              }}
            />
            <i className="Vod-gg-search" />
          </div>
        </MySwiper>
      </div>
    </Container>
  );
}

export default VODCarousel;
